import React, { useLayoutEffect, useRef } from 'react';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { deepEqual } from '@finect/front-utils/deepEqual';
import { withTrackable } from '../withTrackable';
import { dataLayer } from '.';
function runAfterHeadSettled(cb) {
  var done = false;
  var finish = function finish() {
    if (done) return;
    done = true;
    try {
      cb();
    } catch (e) {}
    cleanup();
  };
  var cleanup = function cleanup() {};
  try {
    var head = typeof document !== 'undefined' ? document.head : null;
    if (!head) {
      return requestAnimationFrame(function () {
        return requestAnimationFrame(finish);
      });
    }
    var idleTimer = null;
    var schedule = function schedule() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(finish);
        });
      }, 0);
    };
    var mo = new MutationObserver(function () {
      return schedule();
    });
    mo.observe(head, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });
    cleanup = function cleanup() {
      try {
        mo.disconnect();
      } catch (e) {}
      if (idleTimer) clearTimeout(idleTimer);
    };
    schedule();
    setTimeout(finish, 500);
  } catch (e) {
    requestAnimationFrame(function () {
      return requestAnimationFrame(finish);
    });
  }
}
function DatalayerBeta(props) {
  var id = props.id,
    type = props.type,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    trackHistory = props.trackHistory,
    setTargetingParams = props.setTargetingParams;
  var prevParamsRef = useRef();
  var track = React.useCallback(function () {
    isPreRelease && console.log('[Datalayer] track called', {
      id: id,
      type: type,
      params: params
    });
    var layer = dataLayer({
      id: id,
      type: type,
      params: params
    });
    if (layer && layer.targeting) setTargetingParams(layer.targeting);
  }, [id, type, params, setTargetingParams]);
  var trackReadyScene = React.useCallback(function () {
    isPreRelease && console.log('[Datalayer] sceneReady (scheduled after head settled)');
    runAfterHeadSettled(function () {
      var metaTitle = typeof document !== 'undefined' && document.title || 'unknown';
      isPreRelease && console.log('[Datalayer] sceneReady -> dispatch', {
        metaTitle: metaTitle
      });
      dataLayer({
        id: 'Scene',
        type: 'sceneReady',
        params: {}
      });
    });
  }, []);
  useLayoutEffect(function () {
    isPreRelease && console.log('[Datalayer] effect', {
      phase: prevParamsRef.current === undefined ? 'mount' : 'update',
      id: id,
      type: type,
      params: params,
      prevParams: prevParamsRef.current
    });
    if (prevParamsRef.current === undefined) {
      if (id === 'FiEvent' && (params === null || params === void 0 ? void 0 : params.category) === 'Interaction') {
        isPreRelease && console.log('[Datalayer] Mount: skip FiEvent Interaction');
        prevParamsRef.current = params;
        return;
      }
      if (type === 'ready') {
        isPreRelease && console.log('[Datalayer] Mount: send sceneReady');
        trackReadyScene();
        prevParamsRef.current = params;
        return;
      }
      isPreRelease && console.log('[Datalayer] Mount: track');
      track();
      prevParamsRef.current = params;
      return;
    }
    if (!deepEqual(params, prevParamsRef.current)) {
      if (type === 'ready') {
        isPreRelease && console.log('[Datalayer] Update: send sceneReady');
        trackReadyScene();
        prevParamsRef.current = params;
        return;
      }
      isPreRelease && console.log('[Datalayer] Update: track');
      track();
      prevParamsRef.current = params;
    }
  }, [id, type, params, track, trackReadyScene]);
  return null;
}
export default withTrackable(DatalayerBeta);